import { AmountInfoBoxLocalized } from '@components'

import { AmountInfoBoxesGroup } from '@billy/design-system'
import { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { RecurringInvoiceStatus } from '@features/recurringInvoices/enums/recurringInvoiceStatus'

import { recurringInvoiceStatusToBadgeColor } from '../../../../constants/recurringInvoiceStatusToBadgeColor'
import { getRecurringInvoiceStatusLabel } from '../../../../utils/getRecurringInvoiceStatusLabel'
import { useRecurringInvoicesListFilters } from '../../context/recurringInvoicesListFilters'
import { useRecurringInvoicesSummary } from './hooks/useRecurringInvoiceSummary'

export const RecurringInvoicesSummary = (): ReactElement => {
  const { t } = useTranslation()
  const { recurringInvoicesSummary, isLoading } = useRecurringInvoicesSummary()
  const [{ status: currentStatus }, setFilters] = useRecurringInvoicesListFilters()

  const infoBoxes = useMemo(() => {
    return (Object.keys(recurringInvoicesSummary) as RecurringInvoiceStatus[]).map((status) => ({
      active: status === currentStatus,
      id: status,
      badgeLabel: getRecurringInvoiceStatusLabel(status, t) || '-',
      badgeAmount: recurringInvoicesSummary[status],
      badgeColor: recurringInvoiceStatusToBadgeColor[status],
    }))
  }, [currentStatus, recurringInvoicesSummary, t])

  const handleSummaryBoxClick = useCallback(
    (id: RecurringInvoiceStatus) => {
      setFilters({ page: 1, status: id })
    },
    [setFilters],
  )

  return (
    <AmountInfoBoxesGroup itemsInRow={infoBoxes.length} loading={isLoading}>
      {infoBoxes.map(({ active, badgeAmount, badgeColor, badgeLabel, id }) => (
        <AmountInfoBoxLocalized
          active={active}
          badgeOnly
          badgeAmount={badgeAmount}
          badgeLabel={badgeLabel}
          badgeColor={badgeColor}
          clickable
          id={id}
          key={id}
          onClick={handleSummaryBoxClick}
          shortFormat={false}
        />
      ))}
    </AmountInfoBoxesGroup>
  )
}
